import { Selection, Transaction } from 'prosemirror-state'
import { ReplaceAroundStep, ReplaceStep } from 'prosemirror-transform'

export const selectionToInsertionEnd = (tr: Transaction, bias: 1 | -1 = 1) => {
  let last = tr.steps.length - 1
  let step = tr.steps[last]
  if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep)) return
  let map = tr.mapping.maps[last]
  let end: number | null = null
  map.forEach((_from, _to, _newFrom, newTo) => {
    if (end == null) end = newTo
  })
  tr.setSelection(Selection.near(tr.doc.resolve(end as unknown as number), bias))
}
